// extracted by mini-css-extract-plugin
export default {"container":"I5f4Wb","button":"DT4upb","icon":"IuqbwE","tooltipInner":"_0I_J_S","tooltipText":"Xwtkpz","tooltip":"l8iMFW"};